export default function GeothermalIcon() {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 17.0607C13.7954 17.0607 16.8721 13.9801 16.8721 10.1799C16.8721 6.3798 13.7954 3.29919 10 3.29919C6.20469 3.29919 3.12796 6.3798 3.12796 10.1799C3.12796 13.9801 6.20469 17.0607 10 17.0607Z"
                fill="#F8D5D8"
            />
            <path
                d="M10 3.82847C13.4995 3.82847 16.3434 6.67604 16.3434 10.1799C16.3434 13.6838 13.4995 16.5314 10 16.5314C6.50055 16.5314 3.65657 13.6838 3.65657 10.1799C3.65657 6.67604 6.50055 3.82847 10 3.82847ZM10 2.7699C5.91202 2.7699 2.59933 6.08676 2.59933 10.1799C2.59933 14.2731 5.91202 17.5899 10 17.5899C14.088 17.5899 17.4007 14.2731 17.4007 10.1799C17.4007 6.08676 14.088 2.7699 10 2.7699Z"
                fill="#3F1317"
            />
            <path
                d="M10 12.0924C11.0549 12.0924 11.9101 11.2362 11.9101 10.1799C11.9101 9.12368 11.0549 8.26743 10 8.26743C8.94511 8.26743 8.08994 9.12368 8.08994 10.1799C8.08994 11.2362 8.94511 12.0924 10 12.0924Z"
                fill="#3F1317"
            />
        </svg>
    );
}
